import { Ikon } from 'assets/icons';
import { Button } from 'components/button';
import { Column, Row } from 'layouts/container';
import {
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Radar,
    ResponsiveContainer,
} from 'recharts';
import styles from './channelPerformanceChart.module.css';
import { useCountry } from 'contexts/CountryContext';
  
const data = [
    { metric: 'ROI', google: 120, tiktok: 90, linkedin: 70, facebook: 60, bing: 40 },
    { metric: 'Conversions', google: 110, tiktok: 80, linkedin: 65, facebook: 50, bing: 35 },
    { metric: 'Clicks', google: 130, tiktok: 85, linkedin: 60, facebook: 55, bing: 30 },
    { metric: 'Impressions', google: 140, tiktok: 95, linkedin: 75, facebook: 65, bing: 45 },
];
  
const COLORS = {
    google: '#6A5ACD',    // purple
    tiktok: '#4169E1',    // blue
    linkedin: '#BA55D3',  // violet
    facebook: '#40E0D0',  // turquoise
    bing: '#32CD32',      // lime green
};
  
const legendData = [
    { label: 'Google Ads', key: 'google', value: 121, positive: true },
    { label: 'TikTok Ads', key: 'tiktok', value: 101, positive: true },
    { label: 'LinkedIn Ads', key: 'linkedin', value: 89, positive: false },
    { label: 'Facebook Ads', key: 'facebook', value: 56, positive: false },
    { label: 'Bing Ads', key: 'bing', value: 21, positive: true },
];
  
const ChannelPerformanceChart = () => {
    const { formatCurrency } = useCountry();
    return (
      <Column gap={24}>
        <Column gap={14}>
            <Row gap={16}>
                <Column gap={4}>
                    <h4 className={styles.h4}>Channel Performance</h4>
                </Column>
                <div>
                    <Button 
                        onClick={() => {}} 
                        style={{
                            padding: 0,
                            borderRadius: 0,
                            background: 'transparent',
                            lineHeight: 0,
                            height: 'auto',
                        }} 
                    >
                        <Ikon name={`butn-more-dot`} />
                    </Button>
                </div>
            </Row>
            <div>
                <select className={styles.select}>
                    <option>Daily</option>
                    <option>Weekly</option>
                </select>
            </div>
        </Column>
  
        <ResponsiveContainer width="100%" height={300}>
          <RadarChart outerRadius="80%" data={data}>
            <PolarGrid />
            <PolarAngleAxis dataKey="metric" />
            <PolarRadiusAxis angle={30} domain={[0, 150]} />
            {Object.entries(COLORS).map(([key, color]) => (
              <Radar
                key={key}
                name={key}
                dataKey={key}
                stroke={color}
                fill={color}
                fillOpacity={0.2}
                dot={{ stroke: color, strokeWidth: 2 }}
              />
            ))}
          </RadarChart>
        </ResponsiveContainer>

        <Column gap={20}>
            {legendData.map((item) => (
                <Row key={item.key} gap={6} alignItems={'center'} justifyContent={'flex-end'}>
                    <div className={styles.labelDot} style={{ background: COLORS[item?.key] }}></div>
                    <div className={styles.labelTitle}>{item?.label}</div>
                    <div className={styles.dashedBar}></div>
                    <Row gap={3} width={52} alignItems={'center'}>
                        <Ikon name={item?.positive ? `polygon-up` : `polygon-down`} />
                        <div className={styles.labelValue} style={{ color: item.positive ? '#08B94E' : '#DF1717' }}>{formatCurrency(item?.value)}<span>/day</span></div>
                    </Row>
                </Row>
            ))}
        </Column>
      </Column>
    );
};
  
export default ChannelPerformanceChart;
  